import { CategoriaNotificacaoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type NotificacoesEnviadasFilters = {
  /** Nome do destinatário (busca parcial). */
  destinatario: string
  titulo: string
  categoria?: IOption<CategoriaNotificacaoType>
  push?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<NotificacoesEnviadasFilters>({
    destinatario: '',
    titulo: '',
    categoria: undefined,
    push: undefined,
  })
